<div class="login-page-fullscreen-wrapper home-portal-viewport">
  <div class="weather-aurora-bg"></div>
  <div class="weather-isolines-overlay"></div>

  <div class="home-brand-container">
    <div class="home-logo-avatar-glow anim-fade-up-1">
      <img src="assets/brand/wm_34x34.png" alt="Logo" />
    </div>

    <div class="home-title-zone anim-fade-up-2">
      <h1 class="portal-main-title">METEOFOCUS<span>MANAGER</span></h1>
      <p class="portal-tagline">
        Operational Weather Service & Telemetry Portal
      </p>
    </div>

    <mat-divider class="home-portal-divider anim-fade-up-2"></mat-divider>

    <div class="home-action-zone anim-fade-up-3">
      <button
        mat-flat-button
        class="btn-app-save btn-home-login-trigger"
        routerLink="/login"
        type="button">
        <span>Portal betreten</span>
        <fa-icon
          [icon]="['far', 'arrow-right']"
          class="arrow-trigger-icon"></fa-icon>
      </button>
    </div>
  </div>

  <div class="home-portal-footer anim-fade-in-delayed">
    <span class="footer-system-node">System-Node: Active</span>
    <span class="footer-copyright">© 2026 Wettermanufaktur GmbH</span>
  </div>
</div>
